module.exports = __webpack_public_path__ + "static/media/noInitiatives.b00d9762.png";